var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showSection
    ? _c(
        "section",
        {
          staticClass: "lpu-doctors-list d-flex flex-column",
          class: _setup.isMobile ? "ga-4" : "ga-6",
          attrs: { id: "doctors", "data-qa": "lpu_doctors_list" },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center justify-space-between" },
            [
              _c(
                "h2",
                {
                  staticClass: "lpu-section-title text--text min-w-0",
                  class: _setup.isMobile ? "text-h6" : "text-h5",
                  attrs: {
                    "data-count": _setup.isMobile
                      ? String(_setup.doctorsCount)
                      : _setup.doctorsCountLabel,
                    "data-qa": "lpu_doctors_list_title",
                  },
                },
                [_vm._v("\n      " + _vm._s(_setup.sectionTitle) + "\n    ")]
              ),
              _vm._v(" "),
              _setup.showAllHref && _setup.isMobile
                ? _c(
                    "a",
                    {
                      staticClass:
                        "text-body-2 text-decoration-underline primary--text flex-shrink-0",
                      attrs: {
                        href: _setup.showAllHref,
                        "data-qa": "lpu_doctors_list_all_link",
                      },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_setup.allLinkLabel) + "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.lpu.uses_mtlink ? _c(_setup.DoctorsMtBanner) : _vm._e(),
          _vm._v(" "),
          _setup.specialities.length
            ? _c(_setup.DoctorsFilter, {
                attrs: {
                  specialities: _setup.specialities,
                  "lpu-doctors-url": _setup.lpuDoctorsUrl,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_setup.doctors.length
            ? _c(
                "div",
                {
                  staticClass:
                    "text-body-1 text-secondary--text text-center pa-6",
                  attrs: { "data-qa": "lpu_doctors_list_empty" },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_setup.tStatic("Врачи не найдены")) +
                      ".\n  "
                  ),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "d-flex flex-column",
                  class: _setup.isMobile ? "ga-3" : "ga-4",
                  attrs: { "data-qa": "lpu_doctors_list_cards" },
                },
                _vm._l(_setup.doctors, function (doctor) {
                  return _c(_setup.DoctorCard, {
                    key: doctor.id,
                    attrs: {
                      doctor: doctor,
                      lpu: _vm.lpu,
                      "clinic-slots": _setup.slotsByDoctorId[doctor.id] || {},
                      "is-slots-loading": _setup.isSlotsLoading,
                      "doctor-page-url": _setup.getCardDoctorUrl(doctor),
                      "lpu-not-working-text": _setup.lpuNotWorkingText,
                    },
                  })
                }),
                1
              ),
          _vm._v(" "),
          _setup.showAllHref
            ? _c(_setup.DoctorsShowAllLink, {
                attrs: {
                  href: _setup.showAllHref,
                  label: _setup.showAllButtonLabel,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }